if (!customElements.get('mf-video-gallery')) {
  customElements.define('mf-video-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const on = (el, event, handler) => el.addEventListener(event, handler, { signal: this.controller.signal });
      this.track = this.querySelector('.mf-videos__track');
      this.cards = [...this.querySelectorAll('[data-video-card]')];
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.position = this.querySelector('[data-position]');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = null;
      this.inView = false;
      if (!this.cards.length) { this.hidden = true; return; }
      on(this.previous, 'click', () => this.move(-1));
      on(this.next, 'click', () => this.move(1));
      on(this.track, 'scroll', () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      });
      on(this.track, 'keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      on(document, 'visibilitychange', () => this.update());
      on(this.reducedMotion, 'change', () => this.update());
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.update();
      }, { threshold: .25 });
      this.observer.observe(this.track);
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }
    move(direction) {
      const step = this.cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
      this.track.scrollBy({ left: direction * step, behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
    }
    update() {
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      const bounds = this.track.getBoundingClientRect();
      const visible = this.cards.map((card, i) => ({ i, rect: card.getBoundingClientRect() })).filter(item => item.rect.right > bounds.left + 8 && item.rect.left < bounds.right - 8);
      const range = visible.length > 1 ? (visible[0].i + 1) + '–' + (visible[visible.length - 1].i + 1) : String((visible[0]?.i || 0) + 1);
      this.position.textContent = this.dataset.status.replace('[current]', range).replace('[total]', this.cards.length);
      const mayPlay = this.dataset.preview === 'true' && this.inView && !document.hidden && !this.reducedMotion.matches && !navigator.connection?.saveData;
      this.cards.forEach(card => {
        const video = card.querySelector('video');
        const rect = card.getBoundingClientRect();
        const visibleWidth = Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left);
        if (mayPlay && visibleWidth > rect.width * .25) {
          if (!video.hasAttribute('src')) video.src = video.dataset.src;
          if (video.paused) video.play().catch(() => {});
        } else video.pause();
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.cards?.forEach(card => card.querySelector('video')?.pause());
    }
  });
}
